import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { DashboardPage, FullScreenCard, Loading } from 'components/';
import useAuth from 'hooks/useAuth';
import useShows from 'hooks/useShows';
import SubscriptionProvider from 'providers/Subscription';
import Links from 'views/Links';
import Settings from 'views/Settings';

const DashboardRoutes: React.SFC = () => {
  const { isAuthenticated, doesAccountExist } = useAuth();
  const { loading, selectedShow } = useShows();

  if (!isAuthenticated) {
    return <Redirect to="/signin" />;
  } else if (!doesAccountExist) {
    return <Redirect to="/signup" />;
  } else if (loading || !selectedShow.vanityUrl) {
    return (
      <FullScreenCard>
        <Loading message="Loading..." />
      </FullScreenCard>
    );
  }

  return (
    <DashboardPage>
      <Switch>
        <Route path="/links/:vanityUrl" component={Links} />
        <Route
          path="/settings"
          render={() => (
            <SubscriptionProvider>
              <Settings />
            </SubscriptionProvider>
          )}
        />
        <Redirect from="/links" to={`/links/${selectedShow.vanityUrl}`} />
      </Switch>
    </DashboardPage>
  );
};

export default DashboardRoutes;
